module.exports = __webpack_public_path__ + "media/images/application/template/placeholder-6189a6be5092e780e6a0e9d13a117381.png";